
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("6wI7U", function(module, exports) {

$parcel$export(module.exports, "JiraLossAversionExperiment", () => (parcelRequire("d7mmo")).JiraLossAversionExperiment);

var $d7mmo = parcelRequire("d7mmo");

});
parcelRegister("d7mmo", function(module, exports) {

$parcel$export(module.exports, "JiraLossAversionExperiment", () => $2096677e4ef89c9d$export$2df1ad55126ecabc);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $eI5EY = parcelRequire("eI5EY");

var $5UdbT = parcelRequire("5UdbT");

var $jQeWf = parcelRequire("jQeWf");
const $2096677e4ef89c9d$export$1cec38cf54975982 = ()=>{
    // AA experiment
    const aaExperimentIsEnabled = (0, $eI5EY.fg)('jira_loss_aversion_standard_gate_aa');
    // This function should fire all necessary exposure events for AA experiment
    (0, $5UdbT.useJiraLossAversionAAExperiment)({
        isExperimentEnabled: aaExperimentIsEnabled,
        extraAnalytics: {}
    });
    // AB experiment
    const abExperimentIsEnabled = (0, $eI5EY.fg)('jira_loss_aversion_standard_gate_ab');
    // TODO: use cohort value?
    const { renderTreatment: renderTreatment } = (0, $5UdbT.useJiraLossAversionABExperiment)({
        isExperimentEnabled: abExperimentIsEnabled,
        extraAnalytics: {}
    });
    if (renderTreatment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQeWf.JiraLossAversionModal), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};
const $2096677e4ef89c9d$export$2df1ad55126ecabc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "jiraLossAversionExperiment",
        packageName: "jiraLossAversion",
        teamName: "luna-growth",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2096677e4ef89c9d$export$1cec38cf54975982, null));

});
parcelRegister("5UdbT", function(module, exports) {

$parcel$export(module.exports, "useJiraLossAversionABExperiment", () => $74aceb343d1cb8d2$export$793c69f8a4d1e05);
$parcel$export(module.exports, "useJiraLossAversionAAExperiment", () => $74aceb343d1cb8d2$export$2aef6eaacb8e2488);

var $eUqFw = parcelRequire("eUqFw");


var $9Z2je = parcelRequire("9Z2je");

var $fi8kw = parcelRequire("fi8kw");

var $e84zd = parcelRequire("e84zd");

var $dGcKA = parcelRequire("dGcKA");

var $2pc1v = parcelRequire("2pc1v");

var $haZiZ = parcelRequire("haZiZ");
const $74aceb343d1cb8d2$var$useExperiment = ({ isExperimentEnabled: isExperimentEnabled, extraAnalytics: extraAnalytics, experimentName: experimentName })=>{
    const { isEligible: isEligible, isUrgent: isUrgent } = (0, $9Z2je.useExperimentEligibility)(experimentName);
    const { trialDaysLeft: trialDaysLeft } = (0, $2pc1v.useTrialDetails)();
    const { cohort: cohort, isEnrolled: isEnrolled, isTreatment: isTreatment } = (0, $e84zd.useExperimentEnrollment)({
        experimentName: experimentName,
        skip: !isExperimentEnabled
    });
    const shouldTryShowExperiment = isExperimentEnabled && isEnrolled && isEligible;
    const { canShowExperiment: canShowExperiment } = (0, $fi8kw.useCanShowExperiment)({
        skip: !shouldTryShowExperiment
    });
    const { fireExposureEvents: fireExposureEvents } = (0, $dGcKA.useFireExposureEvents)({
        skip: !canShowExperiment,
        experimentName: experimentName,
        extraAnalytics: {
            ...extraAnalytics,
            isUrgent: isUrgent,
            trialDaysLeft: trialDaysLeft
        }
    });
    (0, $eUqFw.useEffect)(()=>{
        // this is a no-op if skip condition passed to useFireExposureEvents is true
        fireExposureEvents();
    }, [
        fireExposureEvents
    ]);
    if (!canShowExperiment) return {
        cohort: cohort,
        renderTreatment: false
    };
    // We want to set local storage for AA and AB experiments
    (0, $haZiZ.setHasSeenModal)(experimentName, isUrgent);
    return {
        cohort: cohort,
        renderTreatment: isTreatment
    };
};
const $74aceb343d1cb8d2$export$793c69f8a4d1e05 = ({ isExperimentEnabled: isExperimentEnabled, extraAnalytics: extraAnalytics })=>$74aceb343d1cb8d2$var$useExperiment({
        isExperimentEnabled: isExperimentEnabled,
        extraAnalytics: extraAnalytics,
        experimentName: (0, $d08b9e75af3069cb$export$855e843fe464d553)
    });
const $74aceb343d1cb8d2$export$2aef6eaacb8e2488 = ({ isExperimentEnabled: isExperimentEnabled, extraAnalytics: extraAnalytics })=>$74aceb343d1cb8d2$var$useExperiment({
        isExperimentEnabled: isExperimentEnabled,
        extraAnalytics: extraAnalytics,
        experimentName: (0, $d08b9e75af3069cb$export$998e8261e98c7d7d)
    });

});
const $d08b9e75af3069cb$export$998e8261e98c7d7d = 'jira_loss_aversion_standard_aa';
const $d08b9e75af3069cb$export$855e843fe464d553 = 'jira_loss_aversion_standard_ab';

parcelRegister("9Z2je", function(module, exports) {

$parcel$export(module.exports, "useExperimentEligibility", () => $b493e75c1d2e3d98$export$42c0a6ccc8ff1bba);

var $7ZZxN = parcelRequire("7ZZxN");

var $6WXNs = parcelRequire("6WXNs");

var $51hbZ = parcelRequire("51hbZ");

var $e84zd = parcelRequire("e84zd");

var $dgipR = parcelRequire("dgipR");

var $2pc1v = parcelRequire("2pc1v");
const $b493e75c1d2e3d98$var$isDevtestCohort = (cohort)=>cohort === 'devtesting' || cohort === 'devtesting_urgent';
function $b493e75c1d2e3d98$export$42c0a6ccc8ff1bba(experimentName) {
    const { projectType: projectType } = (0, $dgipR.useProjectType)();
    const { jswEdition: jswEdition, billingSourceSystem: billingSourceSystem, trialDaysLeft: trialDaysLeft, isInTrial: isInTrial } = (0, $2pc1v.useTrialDetails)();
    // We include this for our devtesting cohorts. This is not needed for production and should be removed.
    const { cohort: cohort } = (0, $e84zd.useExperimentEnrollment)({
        experimentName: experimentName,
        skip: false
    });
    const isInDevtestCohort = $b493e75c1d2e3d98$var$isDevtestCohort(cohort);
    // Note that a user can be urgent even if they are not eligible
    // It only means that they're in the last few days of a trial
    const isUrgent = isInDevtestCohort ? cohort === 'devtesting_urgent' : isInTrial && !!trialDaysLeft && trialDaysLeft <= 4;
    const hasSeenModal = (0, $51hbZ.getHasSeenModal)(experimentName, isUrgent).hasSeenModal;
    const isEligible = projectType === (0, $7ZZxN.SOFTWARE_PROJECT) && jswEdition === (0, $6WXNs.STANDARD_EDITION) && billingSourceSystem === 'CCP' && // on day 7 there are 8 days left of the trial so this targets days 7 - 14
    // note that for the devtesting cohort we don't even need to be in a trial to be eligible
    (!isInDevtestCohort ? isInTrial && !!trialDaysLeft && trialDaysLeft <= 8 : true) && !hasSeenModal;
    return {
        isEligible: isEligible,
        isUrgent: isUrgent
    };
}

});
parcelRegister("51hbZ", function(module, exports) {

$parcel$export(module.exports, "getHasSeenModal", () => $b0331195865d3e5f$export$9b92cc6b9a20fe8e);


var $8bpps = parcelRequire("8bpps");
function $b0331195865d3e5f$export$9b92cc6b9a20fe8e(expermientName, isUrgent) {
    const isAA = expermientName === (0, $d08b9e75af3069cb$export$998e8261e98c7d7d);
    if (isUrgent) return {
        hasSeenModal: isAA ? (0, $8bpps.getHasSeenUrgentModalAA)() : (0, $8bpps.getHasSeenUrgentModalAB)()
    };
    return {
        hasSeenModal: isAA ? (0, $8bpps.getHasSeenFirstModalAA)() : (0, $8bpps.getHasSeenFirstModalAB)()
    };
}

});
parcelRegister("8bpps", function(module, exports) {

$parcel$export(module.exports, "setHasSeenFirstModalAA", () => $56f1beff23eb2685$export$f975a8547e308d3c);
$parcel$export(module.exports, "getHasSeenFirstModalAA", () => $56f1beff23eb2685$export$942862af653abbd);
$parcel$export(module.exports, "setHasSeenUrgentModalAA", () => $56f1beff23eb2685$export$d1618d387d45e1bf);
$parcel$export(module.exports, "getHasSeenUrgentModalAA", () => $56f1beff23eb2685$export$c029ab5532439a30);
$parcel$export(module.exports, "setHasSeenFirstModalAB", () => $56f1beff23eb2685$export$bce05b2cafc179e7);
$parcel$export(module.exports, "getHasSeenFirstModalAB", () => $56f1beff23eb2685$export$b37380d16b5e55e2);
$parcel$export(module.exports, "setHasSeenUrgentModalAB", () => $56f1beff23eb2685$export$e90779b576d8ea9);
$parcel$export(module.exports, "getHasSeenUrgentModalAB", () => $56f1beff23eb2685$export$50208fb710d06b8b);

var $aZaPn = parcelRequire("aZaPn");
const $56f1beff23eb2685$var$localStorage = (0, $aZaPn.createLocalStorageProvider)('jira-loss-aversion-standard');
const $56f1beff23eb2685$var$FIRST_MODAL_SEEN_AA = 'jla-first-modal-seen-aa';
const $56f1beff23eb2685$var$URGENT_MODAL_SEEN_AA = 'jla-urgent-modal-seen-aa';
const $56f1beff23eb2685$var$FIRST_MODAL_SEEN_AB = 'jla-first-modal-seen-ab';
const $56f1beff23eb2685$var$URGENT_MODAL_SEEN_AB = 'jla-urgent-modal-seen-ab';
const $56f1beff23eb2685$export$f975a8547e308d3c = ()=>{
    $56f1beff23eb2685$var$localStorage.set($56f1beff23eb2685$var$FIRST_MODAL_SEEN_AA, true);
};
const $56f1beff23eb2685$export$942862af653abbd = ()=>$56f1beff23eb2685$var$localStorage.get($56f1beff23eb2685$var$FIRST_MODAL_SEEN_AA) || false;
const $56f1beff23eb2685$export$d1618d387d45e1bf = ()=>{
    $56f1beff23eb2685$var$localStorage.set($56f1beff23eb2685$var$URGENT_MODAL_SEEN_AA, true);
};
const $56f1beff23eb2685$export$c029ab5532439a30 = ()=>$56f1beff23eb2685$var$localStorage.get($56f1beff23eb2685$var$URGENT_MODAL_SEEN_AA) || false;
const $56f1beff23eb2685$export$bce05b2cafc179e7 = ()=>{
    $56f1beff23eb2685$var$localStorage.set($56f1beff23eb2685$var$FIRST_MODAL_SEEN_AB, true);
};
const $56f1beff23eb2685$export$b37380d16b5e55e2 = ()=>$56f1beff23eb2685$var$localStorage.get($56f1beff23eb2685$var$FIRST_MODAL_SEEN_AB) || false;
const $56f1beff23eb2685$export$e90779b576d8ea9 = ()=>{
    $56f1beff23eb2685$var$localStorage.set($56f1beff23eb2685$var$URGENT_MODAL_SEEN_AB, true);
};
const $56f1beff23eb2685$export$50208fb710d06b8b = ()=>$56f1beff23eb2685$var$localStorage.get($56f1beff23eb2685$var$URGENT_MODAL_SEEN_AB) || false;

});


parcelRegister("e84zd", function(module, exports) {

$parcel$export(module.exports, "useExperimentEnrollment", () => $8b800d1fed2d6949$export$feb34becfec7693);

var $79xbN = parcelRequire("79xbN");

function $8b800d1fed2d6949$var$getCohortValue(experimentName) {
    if (experimentName === (0, $d08b9e75af3069cb$export$998e8261e98c7d7d)) {
        // eslint-disable-next-line jira/ff/unsafe-no-exposure
        const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jira_loss_aversion_standard_aa');
        return expConfig.get('cohort', 'not-enrolled');
    }
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jira_loss_aversion_standard_ab');
    return expConfig.get('cohort', 'not-enrolled');
}
function $8b800d1fed2d6949$export$feb34becfec7693({ experimentName: experimentName, skip: skip }) {
    if (skip) return {
        cohort: 'not-enrolled',
        isEnrolled: false,
        isTreatment: false
    };
    const cohort = $8b800d1fed2d6949$var$getCohortValue(experimentName);
    const isTreatment = [
        'test',
        'devtesting',
        'devtesting_urgent'
    ].includes(cohort);
    const isEnrolled = cohort !== 'not-enrolled';
    return {
        cohort: cohort,
        isEnrolled: isEnrolled,
        isTreatment: isTreatment
    };
}

});

parcelRegister("dgipR", function(module, exports) {

$parcel$export(module.exports, "useProjectType", () => $c7374d2f02e81f13$export$6de29d851c914935);

var $7ZZxN = parcelRequire("7ZZxN");

var $cPEpP = parcelRequire("cPEpP");
function $c7374d2f02e81f13$export$6de29d851c914935() {
    // project type (software, service desk, etc) so we can target JSW projects
    // we do not look at whether the project is still loading
    // if data is undefined we will return undefined
    const { data: project } = (0, $cPEpP.useProject)();
    const projectType = (0, $7ZZxN.toProjectType)(project?.type);
    return {
        projectType: projectType
    };
}

});

parcelRegister("2pc1v", function(module, exports) {

$parcel$export(module.exports, "useTrialDetails", () => $d339818490c066a6$export$be2f13183561cb);

var $34FZy = parcelRequire("34FZy");


var $gd0Sp = parcelRequire("gd0Sp");
function $d339818490c066a6$export$be2f13183561cb() {
    const { productEntitlementDetails: productEntitlementDetails, appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const jswEdition = appEditions?.software;
    const entitlementDetails = productEntitlementDetails?.[0, $2edfd53057852e41$export$1346c9aa3cbb477d];
    const billingSourceSystem = entitlementDetails?.billingSourceSystem;
    const trialEndTime = entitlementDetails?.trialEndTime;
    const trialDaysLeft = (0, $34FZy.getTrialDaysLeft)(trialEndTime);
    const isInTrial = !!trialDaysLeft && trialDaysLeft > 0;
    return {
        jswEdition: jswEdition,
        billingSourceSystem: billingSourceSystem,
        trialDaysLeft: trialDaysLeft,
        isInTrial: isInTrial
    };
}

});
parcelRegister("34FZy", function(module, exports) {

$parcel$export(module.exports, "getTrialDaysLeft", () => $060274e6e50e467d$export$954628993bf3188e);
$parcel$export(module.exports, "projectToApplicationKey", () => $060274e6e50e467d$export$1af4fd6f5c543149);

var $7ZZxN = parcelRequire("7ZZxN");

const $060274e6e50e467d$export$9dbbf537dffaafc7 = (timestamp)=>new Date(timestamp).setUTCHours(0, 0, 0, 0);
const $060274e6e50e467d$export$954628993bf3188e = (trialEndTime)=>trialEndTime && Math.ceil(($060274e6e50e467d$export$9dbbf537dffaafc7(trialEndTime) - Date.now()) / 86400000);
const $060274e6e50e467d$export$271517afaa0c15eb = (trialEndTime)=>{
    const trialDaysLeft = $060274e6e50e467d$export$954628993bf3188e(trialEndTime);
    // Technically we do not know whether user is in grace period or not, but if user is able to access the Jira with no payment details
    // and is trialEndTime is missing or over we assume that site is in grace period
    return !trialDaysLeft || trialDaysLeft < 0;
};
const $060274e6e50e467d$export$1af4fd6f5c543149 = (project)=>{
    switch(project){
        // With spork, we should update core projects as it they were Software projects
        case 0, $7ZZxN.SOFTWARE_PROJECT:
        case 0, $7ZZxN.CORE_PROJECT:
            return 0, $2edfd53057852e41$export$1346c9aa3cbb477d;
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 0, $2edfd53057852e41$export$c8c1c8c3f8ddba61;
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return 0, $2edfd53057852e41$export$202f50ee62667e32;
        default:
            throw new Error(`Unsupported project: ${project}`);
    }
};

});
const $2edfd53057852e41$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $2edfd53057852e41$export$e9c56aa3b027d98f = 'jira-customer-service';
const $2edfd53057852e41$export$1346c9aa3cbb477d = 'jira-software';
const $2edfd53057852e41$export$202f50ee62667e32 = 'jira-product-discovery';
const $2edfd53057852e41$export$db515c8cec1e6f79 = 'jira-core';
const $2edfd53057852e41$export$c811f21c9ad05dc2 = 'confluence';
const $2edfd53057852e41$export$961148c98d198270 = 'opsgenie';




parcelRegister("fi8kw", function(module, exports) {

$parcel$export(module.exports, "useCanShowExperiment", () => $9d6362b11c145b49$export$acc3825c421a3bd7);

var $eUqFw = parcelRequire("eUqFw");

var $6uNFR = parcelRequire("6uNFR");
function $9d6362b11c145b49$export$acc3825c421a3bd7({ skip: skip }) {
    const [canShowExperiment, setCanShowExperiment] = (0, $eUqFw.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = (0, $6uNFR.useChoreographer)('jira-loss-aversion-standard', {
        start: ()=>setCanShowExperiment(true),
        stop: ()=>setCanShowExperiment(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        if (!skip) startMessage();
        return ()=>{
            stopMessage();
        };
    }, [
        startMessage,
        stopMessage,
        skip
    ]);
    return {
        canShowExperiment: canShowExperiment
    };
}

});
parcelRegister("6uNFR", function(module, exports) {

$parcel$export(module.exports, "useChoreographer", () => $dbff780bfca374d0$export$9f0e2488ffd90f11);
$parcel$export(module.exports, "useChoreographedRender", () => $dbff780bfca374d0$export$2cfd68294be82811);
$parcel$export(module.exports, "ChoreographedStatusContext", () => $dbff780bfca374d0$export$3ff96dbefca6b00d);
$parcel$export(module.exports, "useChoreographedStatusContext", () => $dbff780bfca374d0$export$2eb1efa814fe4a);

var $eUqFw = parcelRequire("eUqFw");

var $5xY1g = parcelRequire("5xY1g");
var $67SDP = parcelRequire("67SDP");

var $6rW04 = parcelRequire("6rW04");

var $38OPi = parcelRequire("38OPi");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $dbff780bfca374d0$var$environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment')) ?? 'prod';
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const { plugin: $dbff780bfca374d0$export$27fff9a48cfe124b, useChoreographer: $dbff780bfca374d0$export$9f0e2488ffd90f11 } = (0, $5xY1g.choreographerFactory)((0, $67SDP.ProductIds).JIRA, $dbff780bfca374d0$var$environment);
const $dbff780bfca374d0$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const [shouldRender, setShouldRender] = (0, $eUqFw.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $dbff780bfca374d0$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $eUqFw.useEffect)(()=>{
        const startMessageAsync = async ()=>{
            const disposition = await startMessage();
            onMessageDisposition?.(disposition);
        };
        startMessageAsync();
        return ()=>{
            stopMessage();
        };
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage
    ]);
    return shouldRender;
};
const $dbff780bfca374d0$export$3ff96dbefca6b00d = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isAlreadyChoreographedAtAncestor: false
});
const $dbff780bfca374d0$export$2eb1efa814fe4a = ()=>(0, $eUqFw.useContext)($dbff780bfca374d0$export$3ff96dbefca6b00d);

});


parcelRegister("dGcKA", function(module, exports) {

$parcel$export(module.exports, "useFireExposureEvents", () => $ca9844ea5f4416e7$export$5659c1a3e6829401);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $8tM2T = parcelRequire("8tM2T");

var $jMP2a = parcelRequire("jMP2a");

var $e84zd = parcelRequire("e84zd");
const $ca9844ea5f4416e7$export$5659c1a3e6829401 = ({ skip: skip, experimentName: experimentName, extraAnalytics: extraAnalytics })=>{
    const { cohort: cohort } = (0, $e84zd.useExperimentEnrollment)({
        experimentName: experimentName,
        skip: skip
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireExposureEvents = (0, $eUqFw.useCallback)(()=>{
        if (skip) return;
        (0, $8tM2T.default).manuallyLogExperimentExposure(experimentName);
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jlaFeature exposed', {
            experimentName: experimentName,
            cohort: cohort,
            ...extraAnalytics
        });
    }, [
        createAnalyticsEvent,
        cohort,
        skip,
        extraAnalytics,
        experimentName
    ]);
    return {
        fireExposureEvents: fireExposureEvents
    };
};

});

parcelRegister("haZiZ", function(module, exports) {

$parcel$export(module.exports, "setHasSeenModal", () => $f573801e632e52a7$export$43ffcd9228973911);


var $8bpps = parcelRequire("8bpps");
const $f573801e632e52a7$export$43ffcd9228973911 = (expermientName, isUrgent)=>{
    if (expermientName === (0, $d08b9e75af3069cb$export$998e8261e98c7d7d)) isUrgent ? (0, $8bpps.setHasSeenUrgentModalAA)() : (0, $8bpps.setHasSeenFirstModalAA)();
    else isUrgent ? (0, $8bpps.setHasSeenUrgentModalAB)() : (0, $8bpps.setHasSeenFirstModalAB)();
};

});


parcelRegister("jQeWf", function(module, exports) {

$parcel$export(module.exports, "JiraLossAversionModal", () => $8d54b6eaecf96b68$export$bf5226ec0d5ecf12);

var $2Ay3e = parcelRequire("2Ay3e");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $0cdA8 = parcelRequire("0cdA8");

var $dWLk9 = parcelRequire("dWLk9");

var $7m4L0 = parcelRequire("7m4L0");

var $gB2c5 = parcelRequire("gB2c5");

var $ltinT = parcelRequire("ltinT");
const $8d54b6eaecf96b68$export$bf5226ec0d5ecf12 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "jiraLossAversionModal",
        packageName: "jiraLossAversion",
        teamName: "luna-growth",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "loss-aversion.ui.loss-aversion-modal.jira-loss-aversion-modal-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8d54b6eaecf96b68$export$a562bad7894ec750, null)));
const $8d54b6eaecf96b68$export$a562bad7894ec750 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const data = (0, $iWLL0.useLazyLoadQuery)((0, $2Ay3e.default), {
        cloudId: cloudId,
        cloudIds: [
            cloudId
        ],
        offeringKey: 'a70b5cbb-1ae1-4003-8f4a-9001a4a50526'
    });
    const entitlementInfo = data?.tenantContexts?.[0]?.entitlementInfo;
    const entitlement = entitlementInfo?.entitlement;
    const changeOffering = entitlement?.experienceCapabilities?.changeOffering;
    // This might come back as null from graphql but we want to default to undefined to make the types easier to work with
    const upgradeUrl = changeOffering?.experienceUrl || undefined;
    const userCanUpgrade = !!changeOffering?.isAvailableToUser;
    const userCount = entitlementInfo?.__typename === 'CommerceEntitlementInfoCcp' ? entitlementInfo.entitlement?.subscription?.chargeDetails?.chargeQuantities?.[0]?.quantity || 1 : 1;
    if (userCount > 10) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltinT.UserLimitModal), {
        userCanUpgrade: userCanUpgrade,
        upgradeUrl: upgradeUrl,
        userCount: userCount
    });
    const attachmentStorageUsed = data?.jira?.attachmentStorageUsed || 0;
    const GB_IN_BYTES = 1073741824;
    if (attachmentStorageUsed > 2 * GB_IN_BYTES) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gB2c5.StorageModal), {
        userCanUpgrade: userCanUpgrade,
        upgradeUrl: upgradeUrl
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7m4L0.SplitPanelModal), {
        userCanUpgrade: userCanUpgrade,
        upgradeUrl: upgradeUrl
    });
};

});
parcelRegister("2Ay3e", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eb3ec652487b317$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<84e419991b9eb5cb107453d0a12e2a99>>
 * @relayHash 259d6dfdea54bf21521feb6f3b625342
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fafe8277937c37575e176290181bbdf5073f5ce9705c348bb67afd85be56d7f4
const $4eb3ec652487b317$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "offeringKey"
        }
    ], v1 = {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "applicationKey",
                        "value": "JIRA_SOFTWARE"
                    },
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "ScalarField",
                "name": "attachmentStorageUsed"
            }
        ]
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudIds",
            "variableName": "cloudIds"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "jira-software.ondemand"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "offeringKey",
            "variableName": "offeringKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v6 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "concreteType": "CcpChargeDetails",
        "kind": "LinkedField",
        "name": "chargeDetails",
        "plural": false,
        "selections": [
            {
                "concreteType": "CcpChargeQuantity",
                "kind": "LinkedField",
                "name": "chargeQuantities",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "quantity"
                    }
                ]
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "lossAversionModalQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "CcpSubscription",
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software.ondemand\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "lossAversionModalQuery",
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "args": v4 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOffering",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "CcpSubscription",
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software.ondemand\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fafe8277937c37575e176290181bbdf5073f5ce9705c348bb67afd85be56d7f4",
            "metadata": {},
            "name": "lossAversionModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4eb3ec652487b317$var$node.hash = "32da0946b6e9f2dd6ca7ae739da7f654";
var $4eb3ec652487b317$export$2e2bcd8739ae039 = $4eb3ec652487b317$var$node;

});

parcelRegister("7m4L0", function(module, exports) {

$parcel$export(module.exports, "SplitPanelModal", () => $568fbf7a3359a1de$export$c18002dc7c50901b);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $LnhOi = parcelRequire("LnhOi");
var $8pww8 = parcelRequire("8pww8");
var $cni0k = parcelRequire("cni0k");

var $0cdA8 = parcelRequire("0cdA8");
const $568fbf7a3359a1de$export$c18002dc7c50901b = ({ userCanUpgrade: userCanUpgrade, upgradeUrl: upgradeUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "splitPanelModal",
        packageName: "jiraLossAversion",
        teamName: "luna-growth",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($568fbf7a3359a1de$export$ee50c7bc3828b59b, {
        userCanUpgrade: userCanUpgrade,
        upgradeUrl: upgradeUrl
    }));
const $568fbf7a3359a1de$export$ee50c7bc3828b59b = ({ userCanUpgrade: userCanUpgrade, upgradeUrl: upgradeUrl })=>{
    const [showModal, setShowModal] = (0, $eUqFw.useState)(true);
    const onClose = (0, $eUqFw.useCallback)(()=>setShowModal(false), []);
    if (!showModal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cni0k.Modal), {
        title: "PLACEHOLDER:",
        subtitle: "PLACEHOLDER: subtitle",
        onClose: onClose,
        testId: "loss-aversion.ui.loss-aversion-modal.split-panel",
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: onClose,
            appearance: "primary"
        }, "Cancel"),
        right: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LnhOi.Carousel), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pww8.CarouselSlide), {
            title: "Unlimited People"
        }, "Carousel content"))
    }, "SplitPanelModal ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), userCanUpgrade ? `can upgrade at link ${upgradeUrl}` : 'cant upgrade');
};

});
parcelRegister("LnhOi", function(module, exports) {

$parcel$export(module.exports, "Carousel", () => $0dde2252d03792b9$export$144901db2ea8e967);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $lSV8Z = parcelRequire("lSV8Z");
var $5LHuc = parcelRequire("5LHuc");
var $2EVgw = parcelRequire("2EVgw");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $gnlQO = parcelRequire("gnlQO");
const $0dde2252d03792b9$var$containerStyles = (0, $1ZAYh.xcss)({
    overflowX: 'hidden',
    width: '100%',
    paddingBlock: 'space.500',
    paddingInline: 'space.400'
});
const $0dde2252d03792b9$export$144901db2ea8e967 = ({ children: children, onSlideChange: onSlideChange, height: height = 405 })=>{
    const [index, setIndex] = (0, $eUqFw.useState)(0);
    const slides = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children);
    const slide = slides[index];
    const count = slides.length;
    const handleOnPrevious = (0, $eUqFw.useCallback)(()=>{
        const prevIndex = index - 1 < 0 ? count - 1 : index - 1;
        setIndex(prevIndex);
        onSlideChange?.({
            index: prevIndex,
            previousIndex: index
        });
    }, [
        index,
        count,
        onSlideChange
    ]);
    const handleOnNext = (0, $eUqFw.useCallback)(()=>{
        const nextIndex = index + 1 < count ? index + 1 : 0;
        setIndex(nextIndex);
        onSlideChange?.({
            index: nextIndex,
            previousIndex: index
        });
    }, [
        index,
        count,
        onSlideChange
    ]);
    const handleOnSelectIndex = (0, $eUqFw.useCallback)(({ index: nextIndex })=>{
        setIndex(nextIndex);
        onSlideChange?.({
            index: nextIndex,
            previousIndex: index
        });
    }, [
        onSlideChange,
        index
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200",
        xcss: $0dde2252d03792b9$var$containerStyles,
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSV8Z.default), {
        exitThenEnter: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        key: index
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2EVgw.default), {
        enterFrom: "right",
        exitTo: "left",
        fade: "inout",
        duration: (0, $5LHuc.mediumDurationMs)
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            style: {
                height: height
            },
            ...props,
            id: `slide${index}`
        }, slide)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dXKde))),
        label: "Previous",
        onClick: handleOnPrevious
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gnlQO.default), {
        selectedIndex: index,
        values: slides.map((_, idx)=>idx),
        onSelect: handleOnSelectIndex,
        appearance: "primary",
        ariaControls: "slide"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))),
        label: "Next",
        onClick: handleOnNext
    })));
};

});
parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2a4a1e4b9148f86$var$_chevronLeft = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $a2a4a1e4b9148f86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $a2a4a1e4b9148f86$var$_chevronLeft.default,
        iconType: "utility"
    }));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = module.exports.default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;

});
parcelRegister("a4cVy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c9a4dab2c89c59f70c69196708396b94>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75444e382f2d4220$var$_react = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75444e382f2d4220$var$_UNSAFE_baseNew = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75444e382f2d4220$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75444e382f2d4220$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $75444e382f2d4220$var$_react.default.createElement($75444e382f2d4220$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="m8 10.75-4.5-4.5L8 1.75"/>`,
        type: 'utility'
    }, props));
$75444e382f2d4220$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $75444e382f2d4220$var$_default = module.exports.default = $75444e382f2d4220$var$ChevronLeftIcon;

});


parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9d7d0ffff46f5f00$var$_chevronRight = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $9d7d0ffff46f5f00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9d7d0ffff46f5f00$var$_chevronRight.default,
        iconType: "utility"
    }));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = module.exports.default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;

});

parcelRegister("gnlQO", function(module, exports) {

$parcel$export(module.exports, "default", () => $24f510a9e7e3fedf$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");

var $5gfRs = parcelRequire("5gfRs");

var $2EgO8 = parcelRequire("2EgO8");
const $24f510a9e7e3fedf$var$packageName = "platform-pkg";
const $24f510a9e7e3fedf$var$packageVersion = "0.0.0-use.local";
/**
 * __ProgressDots__
 *
 * A progress indicator shows the user where they are along the steps of a journey.
 */ const $24f510a9e7e3fedf$var$ProgressDots = ({ appearance: appearance = 'default', ariaControls: ariaControls = 'panel', ariaLabel: ariaLabel = 'tab', size: size = 'default', // NOTE: `spacing` is a reserved HTML attribute and will be added to the
// element, replaced with `gutter`.
spacing: gutter = 'comfortable', selectedIndex: selectedIndex, testId: testId, values: values, onSelect: onSelect })=>{
    const tablistRef = (0, $eUqFw.useRef)(null);
    const onSelectWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onSelect || (0, $5Q9wj.default),
        action: 'selected',
        componentName: 'progressIndicator',
        packageName: $24f510a9e7e3fedf$var$packageName,
        packageVersion: $24f510a9e7e3fedf$var$packageVersion
    });
    const [inlineGapValue, rawGapValue] = (0, $5gfRs.progressIndicatorGapMap)[gutter][size];
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        const indicators = Array.from(tablistRef.current.children);
        // bail if the target isn't an indicator
        if (!indicators.includes(event.target)) return;
        // bail if not valid arrow key
        const isLeft = event.key === 'ArrowLeft';
        const isRight = event.key === 'ArrowRight';
        if (!isLeft && !isRight) return;
        // bail if at either end of the values
        const isAlpha = isLeft && selectedIndex === 0;
        const isOmega = isRight && selectedIndex === values.length - 1;
        if (isAlpha || isOmega) return;
        const index = isLeft ? selectedIndex - 1 : selectedIndex + 1;
        // call the consumer's select method and focus the applicable indicator
        if (onSelect) onSelectWithAnalytics({
            event: event,
            index: index
        });
        if (typeof indicators[index].focus === 'function') indicators[index].focus();
    }, [
        onSelectWithAnalytics,
        selectedIndex,
        values,
        onSelect
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!onSelect) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(document, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: false
            }
        });
    }, [
        onSelect,
        handleKeyDown
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $5gfRs.varDotsSize)]: `${(0, $5gfRs.sizes)[size]}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $5gfRs.varDotsMargin)]: rawGapValue
        },
        role: onSelect && 'tablist'
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        testId: testId,
        ref: (r)=>{
            tablistRef.current = r;
        },
        alignInline: "center",
        space: inlineGapValue
    }, values.map((_, index)=>{
        const isSelected = selectedIndex === index;
        const tabId = `${ariaLabel}${index}`;
        const panelId = `${ariaControls}${index}`;
        const indicatorTestId = testId && `${testId}-ind-${index}`;
        return onSelect ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $2EgO8.ButtonIndicator), {
            key: index,
            testId: indicatorTestId,
            appearance: appearance,
            isSelected: isSelected,
            tabId: tabId,
            panelId: panelId,
            onClick: (event)=>onSelectWithAnalytics({
                    event: event,
                    index: index
                })
        }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $2EgO8.PresentationalIndicator), {
            key: index,
            testId: indicatorTestId,
            appearance: appearance,
            isSelected: isSelected
        });
    })));
};
var $24f510a9e7e3fedf$export$2e2bcd8739ae039 = $24f510a9e7e3fedf$var$ProgressDots;

});
parcelRegister("5gfRs", function(module, exports) {

$parcel$export(module.exports, "progressIndicatorGapMap", () => $509959c700b79938$export$c7b941bbc227445b);
$parcel$export(module.exports, "sizes", () => $509959c700b79938$export$c647cb0ee6e282fe);
$parcel$export(module.exports, "varDotsSize", () => $509959c700b79938$export$83c4f86b79228049);
$parcel$export(module.exports, "varDotsMargin", () => $509959c700b79938$export$b391856a24c21681);
const $509959c700b79938$export$c7b941bbc227445b = {
    comfortable: {
        small: [
            'space.075',
            "var(--ds-space-075, 6px)"
        ],
        default: [
            'space.100',
            "var(--ds-space-100, 8px)"
        ],
        large: [
            'space.150',
            "var(--ds-space-150, 12px)"
        ]
    },
    cozy: {
        small: [
            'space.050',
            "var(--ds-space-050, 4px)"
        ],
        default: [
            'space.075',
            "var(--ds-space-075, 6px)"
        ],
        large: [
            'space.100',
            "var(--ds-space-100, 8px)"
        ]
    },
    compact: {
        small: [
            'space.025',
            "var(--ds-space-025, 2px)"
        ],
        default: [
            'space.050',
            "var(--ds-space-050, 4px)"
        ],
        large: [
            'space.075',
            "var(--ds-space-075, 6px)"
        ]
    }
};
const $509959c700b79938$export$c647cb0ee6e282fe = {
    small: 4,
    default: 8,
    large: 12
};
const $509959c700b79938$export$83c4f86b79228049 = '--ds-dots-size';
const $509959c700b79938$export$b391856a24c21681 = '--ds-dots-margin';

});

parcelRegister("2EgO8", function(module, exports) {

$parcel$export(module.exports, "PresentationalIndicator", () => $9952f418e4b1634d$export$ec3c81af58a0c4e7);
$parcel$export(module.exports, "ButtonIndicator", () => $9952f418e4b1634d$export$3716cb524d6018c1);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $lkPEe = parcelRequire("lkPEe");

var $5gfRs = parcelRequire("5gfRs");
// TODO Token usages are not consistent for dots https://product-fabric.atlassian.net/browse/DSP-3180
const $9952f418e4b1634d$var$colorMap = {
    default: (0, $1ZAYh.xcss)({
        backgroundColor: 'color.background.neutral'
    }),
    help: (0, $1ZAYh.xcss)({
        backgroundColor: 'color.background.neutral'
    }),
    inverted: (0, $1ZAYh.xcss)({
        // @ts-expect-error
        backgroundColor: "var(--ds-icon-subtle, #626F86)"
    }),
    primary: (0, $1ZAYh.xcss)({
        backgroundColor: 'color.background.neutral'
    })
};
const $9952f418e4b1634d$var$selectedColorMap = {
    default: (0, $1ZAYh.xcss)({
        // @ts-expect-error
        backgroundColor: "var(--ds-icon, #44546F)"
    }),
    help: (0, $1ZAYh.xcss)({
        // @ts-expect-error
        backgroundColor: "var(--ds-icon-discovery, #8270DB)"
    }),
    inverted: (0, $1ZAYh.xcss)({
        // @ts-expect-error
        backgroundColor: "var(--ds-icon-inverse, #FFFFFF)"
    }),
    primary: (0, $1ZAYh.xcss)({
        // @ts-expect-error
        backgroundColor: "var(--ds-icon-brand, #0C66E4)"
    })
};
const $9952f418e4b1634d$var$commonStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `var(${(0, $5gfRs.varDotsSize)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `var(${(0, $5gfRs.varDotsSize)})`,
    position: 'relative',
    borderRadius: 'border.radius.circle',
    '::before': {
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(var(${(0, $5gfRs.varDotsSize)}) + var(${(0, $5gfRs.varDotsMargin)}))`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(var(${(0, $5gfRs.varDotsSize)}) + var(${(0, $5gfRs.varDotsMargin)}))`,
        position: 'absolute',
        content: '""',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(-1 * var(${(0, $5gfRs.varDotsMargin)}) / 2)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `calc(-1 * var(${(0, $5gfRs.varDotsMargin)}) / 2)`
    }
});
const $9952f418e4b1634d$var$buttonStyles = (0, $1ZAYh.xcss)({
    padding: 'space.0',
    border: 0,
    cursor: 'pointer',
    outline: 0
});
const $9952f418e4b1634d$export$ec3c81af58a0c4e7 = ({ appearance: appearance, isSelected: isSelected, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: testId,
        xcss: [
            $9952f418e4b1634d$var$commonStyles,
            appearance === 'default' && !isSelected && $9952f418e4b1634d$var$colorMap['default'],
            appearance === 'help' && !isSelected && $9952f418e4b1634d$var$colorMap['help'],
            appearance === 'inverted' && !isSelected && $9952f418e4b1634d$var$colorMap['inverted'],
            appearance === 'primary' && !isSelected && $9952f418e4b1634d$var$colorMap['primary'],
            appearance === 'default' && isSelected && $9952f418e4b1634d$var$selectedColorMap['default'],
            appearance === 'help' && isSelected && $9952f418e4b1634d$var$selectedColorMap['help'],
            appearance === 'inverted' && isSelected && $9952f418e4b1634d$var$selectedColorMap['inverted'],
            appearance === 'primary' && isSelected && $9952f418e4b1634d$var$selectedColorMap['primary']
        ]
    });
const $9952f418e4b1634d$export$3716cb524d6018c1 = ({ appearance: appearance, panelId: panelId, tabId: tabId, isSelected: isSelected, onClick: onClick, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        role: "tab",
        xcss: [
            $9952f418e4b1634d$var$commonStyles,
            $9952f418e4b1634d$var$buttonStyles,
            appearance === 'default' && !isSelected && $9952f418e4b1634d$var$colorMap['default'],
            appearance === 'help' && !isSelected && $9952f418e4b1634d$var$colorMap['help'],
            appearance === 'inverted' && !isSelected && $9952f418e4b1634d$var$colorMap['inverted'],
            appearance === 'primary' && !isSelected && $9952f418e4b1634d$var$colorMap['primary'],
            appearance === 'default' && isSelected && $9952f418e4b1634d$var$selectedColorMap['default'],
            appearance === 'help' && isSelected && $9952f418e4b1634d$var$selectedColorMap['help'],
            appearance === 'inverted' && isSelected && $9952f418e4b1634d$var$selectedColorMap['inverted'],
            appearance === 'primary' && isSelected && $9952f418e4b1634d$var$selectedColorMap['primary']
        ],
        "aria-controls": panelId,
        "aria-selected": isSelected,
        id: tabId,
        onClick: onClick,
        tabIndex: isSelected ? -1 : undefined,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, tabId));
};

});



parcelRegister("8pww8", function(module, exports) {

$parcel$export(module.exports, "CarouselSlide", () => $29fb4c79704594d5$export$cabb5ccfbd60cbd4);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");
const $29fb4c79704594d5$var$containerStyles = (0, $1ZAYh.xcss)({
    height: '100%'
});
const $29fb4c79704594d5$var$headingStyles = (0, $1ZAYh.xcss)({
    textAlign: 'center'
});
const $29fb4c79704594d5$var$childrenStyles = (0, $1ZAYh.xcss)({
    overflowY: 'auto',
    width: '100%',
    flexGrow: 1,
    height: '100%'
});
const $29fb4c79704594d5$var$titleStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-regular, 400)",
    textAlign: 'center',
    // Remove the automatic margin applied to p tags.
    marginTop: 'space.0'
});
const $29fb4c79704594d5$export$cabb5ccfbd60cbd4 = ({ heading: heading, children: children, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200",
        alignInline: "center",
        xcss: $29fb4c79704594d5$var$containerStyles,
        testId: "growth-pattern-library-modal-carousel-slide"
    }, heading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $29fb4c79704594d5$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "span",
        size: "small"
    }, heading)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $29fb4c79704594d5$var$childrenStyles
    }, children), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "p",
        xcss: $29fb4c79704594d5$var$titleStyles
    }, title) : null);

});

parcelRegister("cni0k", function(module, exports) {

$parcel$export(module.exports, "Modal", () => $7b50e0b4ded77a31$export$2b77a92f1a5ad772);

var $eUqFw = parcelRequire("eUqFw");

var $aOw1G = parcelRequire("aOw1G");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Ywu9 = parcelRequire("4Ywu9");

var $2HfCk = parcelRequire("2HfCk");

var $bk4nb = parcelRequire("bk4nb");

var $hjQtW = parcelRequire("hjQtW");
const $7b50e0b4ded77a31$var$container = (0, $1ZAYh.xcss)({
    overflowY: 'auto',
    height: '100%',
    [(0, $4Ywu9.media).above.sm]: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr'
    }
});
const $7b50e0b4ded77a31$var$stack = (0, $1ZAYh.xcss)({
    height: '100%',
    padding: 'space.600',
    overflowY: 'auto'
});
const $7b50e0b4ded77a31$var$rightContainer = (0, $1ZAYh.xcss)({
    display: 'none',
    [(0, $4Ywu9.media).above.sm]: {
        backgroundColor: 'color.background.accent.gray.subtlest',
        display: 'flex',
        width: '100%',
        overflowY: 'auto'
    }
});
const $7b50e0b4ded77a31$export$2b77a92f1a5ad772 = ({ logo: logo, title: title, subtitle: subtitle, children: children, actions: actions, right: right, ...modalProps })=>{
    const includesRight = right !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: includesRight ? 'x-large' : undefined,
        autoFocus: false,
        ...modalProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: includesRight && $7b50e0b4ded77a31$var$container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.400",
        xcss: $7b50e0b4ded77a31$var$stack
    }, logo, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hjQtW.ModalTitle), null, title), subtitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtle",
        size: "medium"
    }, subtitle) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2HfCk.ModalBody), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bk4nb.ModalFooter), null, actions)), includesRight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $7b50e0b4ded77a31$var$rightContainer
    }, right)));
};

});
parcelRegister("2HfCk", function(module, exports) {

$parcel$export(module.exports, "ModalBody", () => $83bd5d916908ac90$export$cb540d8b0ef7906c);

var $eUqFw = parcelRequire("eUqFw");

var $8MHxr = parcelRequire("8MHxr");

var $cMtFc = parcelRequire("cMtFc");

var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");
const $83bd5d916908ac90$var$container = (0, $1ZAYh.xcss)({
    flex: '1 1 auto',
    overflowY: 'auto'
});
const $83bd5d916908ac90$export$cb540d8b0ef7906c = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $cMtFc.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8MHxr.TouchScrollable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.300",
        xcss: $83bd5d916908ac90$var$container,
        testId: testId
    }, children));
};

});

parcelRegister("bk4nb", function(module, exports) {

$parcel$export(module.exports, "ModalFooter", () => $dc1b82263d922623$export$519437715052e656);

var $eUqFw = parcelRequire("eUqFw");

var $cMtFc = parcelRequire("cMtFc");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");
const $dc1b82263d922623$var$wrapStyles = (0, $1ZAYh.xcss)({
    flexWrap: 'wrap-reverse'
});
const $dc1b82263d922623$export$519437715052e656 = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $cMtFc.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignInline: "end",
        testId: testId,
        space: "space.150",
        xcss: $dc1b82263d922623$var$wrapStyles
    }, children);
};

});

parcelRegister("hjQtW", function(module, exports) {

$parcel$export(module.exports, "ModalTitle", () => $c37d1910e4ade1bf$export$b26fae16ba5468aa);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $cMtFc = parcelRequire("cMtFc");
const $c37d1910e4ade1bf$export$b26fae16ba5468aa = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $cMtFc.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        testId: testId,
        size: "large",
        id: titleId
    }, children);
};

});



parcelRegister("gB2c5", function(module, exports) {

$parcel$export(module.exports, "StorageModal", () => $ba995786e4465c50$export$de0de9a0c528fc33);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $LnhOi = parcelRequire("LnhOi");
var $8pww8 = parcelRequire("8pww8");
var $cni0k = parcelRequire("cni0k");

var $0cdA8 = parcelRequire("0cdA8");
const $ba995786e4465c50$export$de0de9a0c528fc33 = ({ userCanUpgrade: userCanUpgrade, upgradeUrl: upgradeUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "storageModal",
        packageName: "jiraLossAversion",
        teamName: "luna-growth",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba995786e4465c50$export$a6bf7c84b3543a58, {
        userCanUpgrade: userCanUpgrade,
        upgradeUrl: upgradeUrl
    }));
const $ba995786e4465c50$export$a6bf7c84b3543a58 = ({ userCanUpgrade: userCanUpgrade, upgradeUrl: upgradeUrl })=>{
    const [showModal, setShowModal] = (0, $eUqFw.useState)(true);
    const onClose = (0, $eUqFw.useCallback)(()=>setShowModal(false), []);
    if (!showModal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cni0k.Modal), {
        title: "PLACEHOLDER:",
        subtitle: "PLACEHOLDER: subtitle",
        onClose: onClose,
        testId: "loss-aversion.ui.loss-aversion-modal.storage",
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: onClose,
            appearance: "primary"
        }, "Cancel"),
        right: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LnhOi.Carousel), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8pww8.CarouselSlide), {
            title: "Unlimited People"
        }, "Carousel content"))
    }, "StorageModal ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), userCanUpgrade ? `can upgrade at link ${upgradeUrl}` : 'cant upgrade');
};

});

parcelRegister("ltinT", function(module, exports) {

$parcel$export(module.exports, "UserLimitModal", () => $c822461c9c14ec4f$export$c6f94866be4fd825);

var $4gfBs = parcelRequire("4gfBs");

var $eUqFw = parcelRequire("eUqFw");

var $iWLL0 = parcelRequire("iWLL0");

var $bFzGY = parcelRequire("bFzGY");

var $7u4fN = parcelRequire("7u4fN");

var $cni0k = parcelRequire("cni0k");

var $0cdA8 = parcelRequire("0cdA8");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");

var $dWLk9 = parcelRequire("dWLk9");
const $c822461c9c14ec4f$export$c6f94866be4fd825 = ({ userCanUpgrade: userCanUpgrade, upgradeUrl: upgradeUrl, userCount: userCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "userLimitModal",
        packageName: "jiraLossAversion",
        teamName: "luna-growth",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c822461c9c14ec4f$export$ec23fbe1e263ce95, {
        userCount: userCount,
        userCanUpgrade: userCanUpgrade,
        upgradeUrl: upgradeUrl
    }));
const $c822461c9c14ec4f$export$ec23fbe1e263ce95 = ({ userCanUpgrade: userCanUpgrade, upgradeUrl: upgradeUrl, userCount: userCount })=>{
    const [showModal, setShowModal] = (0, $eUqFw.useState)(true);
    const onClose = ()=>setShowModal(false);
    const [userAvatars, setUserAvatars] = (0, $eUqFw.useState)(null);
    const [loadingAvatars, setLoadingAvatars] = (0, $eUqFw.useState)(true);
    const [avatarsError, setAvatarsError] = (0, $eUqFw.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const data = (0, $iWLL0.useLazyLoadQuery)((0, $4gfBs.default), {
        cloudId: cloudId
    });
    const projectKeys = (0, $eUqFw.useMemo)(()=>data?.jira?.allJiraProjects?.edges?.map((edge)=>edge?.node?.key) || [], [
        data
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                const usersResponse = await (0, $lRmyA.performGetRequestWithRetry)(`/rest/api/3/user/assignable/multiProjectSearch?projectKeys=${projectKeys.join(',')}&maxResults=100`);
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'fetched userAvatars', {});
                setUserAvatars(usersResponse);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'fetchUserAvatarsWithRetry',
                        packageName: 'jiraLossAversion'
                    }
                });
                setAvatarsError(error.message || 'Unknown avatar fetch error');
            } finally{
                setLoadingAvatars(false);
            }
        };
        fetchData();
    }, [
        projectKeys,
        createAnalyticsEvent
    ]);
    if (!showModal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cni0k.Modal), {
        title: "PLACEHOLDER:",
        subtitle: "PLACEHOLDER: subtitle",
        onClose: onClose,
        testId: "loss-aversion.ui.loss-aversion-modal.user-limit",
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: onClose,
            appearance: "primary"
        }, "Cancel")
    }, userCanUpgrade ? `can upgrade at link ${upgradeUrl}` : 'cant upgrade', loadingAvatars && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, "Loading..."), avatarsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, "Error: ", avatarsError), !loadingAvatars && !avatarsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, "projectKeys: ", projectKeys.join(','), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), "userAvatars?: ", !!userAvatars, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), "userCount: ", userCount));
};

});
parcelRegister("4gfBs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ec18bae0db026e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<73eef4e04fd8c30eb8d15c6dc07a4de8>>
 * @relayHash ad8882ecb6670359b684202c34cd11f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f01d2dcbf15026d7e29e8dee47801496827b165db2e83daea189e41c6bab8c1a
const $7ec18bae0db026e7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "sortBy": {
                    "order": "ASC",
                    "sortBy": "KEY"
                },
                "types": "SOFTWARE"
            }
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 100
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "userLimitModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "userLimitModalQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f01d2dcbf15026d7e29e8dee47801496827b165db2e83daea189e41c6bab8c1a",
            "metadata": {},
            "name": "userLimitModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7ec18bae0db026e7$var$node.hash = "bbcd803edbb82700dc92e521570b35eb";
var $7ec18bae0db026e7$export$2e2bcd8739ae039 = $7ec18bae0db026e7$var$node;

});






//# sourceMappingURL=async-jira-loss-aversion-modal-feature.e5da36f0.js.map
